import { render, staticRenderFns } from "./fileDataMoon.vue?vue&type=template&id=7127f6fb&scoped=true&"
import script from "./fileDataMoon.vue?vue&type=script&lang=js&"
export * from "./fileDataMoon.vue?vue&type=script&lang=js&"
import style0 from "./fileDataMoon.vue?vue&type=style&index=0&id=7127f6fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7127f6fb",
  null
  
)

export default component.exports